<!-- <section class="mainclass">
  <div class="container-fluid">
    <div class="row">
      <div class="loginmaindiv">
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
          <div class="admin_login_logo" *ngIf="isMobile">
            <a href="" routerLink="/mobile/mobileview"><img src="../../assets/GoldBharatone.png" /></a>
          </div>
          <div class="admin_login_logo" *ngIf="!isMobile">
            <a href="" routerLink=""><img src="../../assets/GoldBharatone.png" /></a>
          </div>
          <div class="admin_login_title">
            <h5 class="register-heading">Hello! Register to get started</h5>
            <h6 class="Business-Information-heading" [ngStyle]="{'color': color_two}">Business Information </h6>
          </div>
          <label class="my-labels" [ngStyle]="{'color': color}">Business Name <span
              class="validationError">*</span></label>
          <div class="login-input-div">
            <input formControlName="businessName" placeholder=" Ex: Retail Gold" type="text" class="input-filed" />
            <div class="validationError" *ngIf="
            registerForm.get('businessName')?.hasError('pattern') &&
            registerForm.get('businessName')?.touched
          ">
              Please enter a valid name.
            </div>
            <div class="validationError" *ngIf="
            registerForm.get('businessName')?.hasError('required') &&
            registerForm.get('businessName')?.touched
          ">
              Business Name is required.
            </div>
          </div>

          <label class="my-labels" [ngStyle]="{'color': color}">Person Full Name <span
              class="validationError">*</span></label>
          <div class="login-input-div">
            <input placeholder=" Ex: Kumar" formControlName="personName" type="text" class="input-filed" />
            <div class="validationError" *ngIf="
                registerForm.get('personName')?.hasError('required') &&
                registerForm.get('personName')?.touched
              ">
              Name is required.
            </div>
            <div class="validationError" *ngIf="
            registerForm.get('personName')?.hasError('pattern') &&
            registerForm.get('personName')?.touched
          ">
              Please enter a valid name.
            </div>
          </div>
          <label class="my-labels" [ngStyle]="{'color': color}">Email <span class="validationError">*</span></label>
          <div class="login-input-div">
            <input placeholder=" Ex: *********@gmail.com" type="text" class="input-filed" formControlName="email" />
            <div class="validationError" *ngIf="
                registerForm.get('email')?.hasError('required') &&
                registerForm.get('email')?.touched
              ">
              Email number is required.
            </div>
            <div class="validationError" *ngIf="
                registerForm.get('email')?.hasError('email') &&
                registerForm.get('email')?.touched
              ">
              Please enter a valid email.
            </div>
          </div>
          <label class="my-labels" [ngStyle]="{'color': color}">Phone Number <span
              class="validationError">*</span></label>
          <div class="login-input-div">
            <input minlength="10" maxlength="10" placeholder=" Ex: 891******4" type="text" class="input-filed"
              formControlName="phone" />
            <div class="validationError" *ngIf="
                registerForm.get('phone')?.hasError('required') &&
                registerForm.get('phone')?.touched
              ">
              Mobile number is required.
            </div>
            <div class="validationError" *ngIf="
                registerForm.get('phone')?.hasError('pattern') &&
                registerForm.get('phone')?.touched
              ">
              Please enter a valid mobile number.
            </div>
          </div>
          <label class="my-labels" [ngStyle]="{'color': color}">Shop Establish Date <span
              class="validationError">*</span></label>
          <div class="login-input-div">
            <input placeholder=" Ex: +91**********" type="date" class="input-filed" formControlName="establishedDate" />
   
            <div class="validationError" *ngIf="
              registerForm.get('establishedDate')?.hasError('required') &&
              registerForm.get('establishedDate')?.touched
              ">
              Date is required.
            </div>

    
            <div class="validationError" *ngIf="
              registerForm.get('establishedDate')?.hasError('futureDate') &&
              registerForm.get('establishedDate')?.touched
              ">
            You cannot enter beyond present date.
            </div>
          </div>
          <label class="my-labels" [ngStyle]="{'color': color}">Pincode <span class="validationError">*</span></label>
          <div class="login-input-div">
            <input placeholder=" Ex: 5*****" type="text" formControlName="pincode" minlength="6" maxlength="6"
              (input)="getArea()" [(ngModel)]="pin" class="input-filed" />
            <div class="validationError" *ngIf="
                registerForm.get('pincode')?.hasError('required') &&
                registerForm.get('pincode')?.touched
              ">
              Pin number is required.
            </div>
            <div class="validationError" *ngIf="
                registerForm.get('pincode')?.hasError('pattern') &&
                registerForm.get('pincode')?.touched
              ">
              Please enter a valid pin code.
            </div>
          </div>
        
          <div *ngIf="isPinAvailble">
            <div class="input">
              <label class="my-labels" [ngStyle]="{'color': color}">Circle <span
                  class="validationError">*</span></label>
              <p *ngFor="let ar of pinArea" class="radio">
                <input type="radio" formControlName="circle" [value]="ar?.Name" />
                {{ ar?.Name }}
              </p>
              <div class="validationError" *ngIf="
                  registerForm.get('circle')?.hasError('required') &&
                  registerForm.get('circle')?.touched
                ">
                Business address is required.
              </div>
            </div>

            <div class="input">
              <label for="lname" class="my-labels" [ngStyle]="{'color': color}"> City <span
                  class="validationError">*</span></label>
              <div>
                <input type="text" id="lname" formControlName="city" [(ngModel)]="isCity" class="input-filed"
                  readonly />
              </div>
            </div>

            <div class="input">
              <label for="lname" class="my-labels" [ngStyle]="{'color': color}">State <span
                  class="validationError">*</span></label>
              <div>
                <input type="text" id="lname" formControlName="state" [(ngModel)]="isState" class="input-filed"
                  readonly />
              </div>
            </div>
            <div class="input">
              <label for="lname" class="my-labels" [ngStyle]="{'color': color}">Business Address<span
                  class="validationError">*</span></label>
              <div>
                <textarea class="input-filed" formControlName="businessAddress"></textarea>
              </div>
              <div class="validationError" *ngIf="
                  registerForm.get('businessAddress')?.hasError('required') &&
                  registerForm.get('businessAddress')?.touched
                ">
                Business address is required.
              </div>
            </div>
          </div>

          <div class="loginbotn-div">
            <button class="login-btn" type="submit" [ngStyle]="{'background-color': color_two}"
              *ngIf="registerForm.valid">
              Register
            </button>
            <button class="login-btn-invalid" type="submit" *ngIf="!registerForm.valid"
              [disabled]="!registerForm.valid">
              Register
            </button>
          </div>
          <div class="admin_login_content">
            <p>
              Already have an account?
              <span class="Register-spans" [ngStyle]="{'color': color}" routerLink="/login">Login Now</span>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</section> -->




<!-- <section class="register-page">
  <div class="register-card">

    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">

      <h2>Hello! Register to get started</h2>

      <p class="sub-title">Business Information</p>


      <div class="form-group">
        <label>Business Name <span class="required">*</span></label>

        <input
          type="text"
          class="custom-input"
          placeholder="Business Name"
          formControlName="businessName">

        <small class="validationError"
          *ngIf="registerForm.get('businessName')?.invalid && registerForm.get('businessName')?.touched">

          Business Name is required

        </small>

      </div>

    

      <div class="form-group">

        <label>Person Full Name <span class="required">*</span></label>

        <input
          type="text"
          class="custom-input"
          placeholder="Person Full Name"
          formControlName="personName">

        <small class="validationError"
          *ngIf="registerForm.get('personName')?.invalid && registerForm.get('personName')?.touched">

          Person Name is required

        </small>

      </div>

   

      <div class="form-group">

        <label>Email <span class="required">*</span></label>

        <input
          type="email"
          class="custom-input"
          placeholder="Email Address"
          formControlName="email">

        <small class="validationError"
          *ngIf="registerForm.get('email')?.invalid && registerForm.get('email')?.touched">

          Valid Email is required

        </small>

      </div>



      <div class="form-group">

        <label>Phone Number <span class="required">*</span></label>

        <input
          type="text"
          maxlength="10"
          class="custom-input"
          placeholder="Phone Number"
          formControlName="phone">

        <small class="validationError"
          *ngIf="registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched">

          Phone Number is required

        </small>

      </div>

 

      <div class="form-group">

        <label>Shop Establish Date <span class="required">*</span></label>

        <input
          type="date"
          class="custom-input"
          formControlName="establishedDate">

      </div>

  

      <div class="form-group">

        <label>Pincode <span class="required">*</span></label>

        <input
          type="text"
          maxlength="6"
          class="custom-input"
          placeholder="Pincode"
          formControlName="pincode"
          [(ngModel)]="pin"
          (input)="getArea()">

      </div>

  

      <div *ngIf="isPinAvailble" class="form-group">

        <label>Circle</label>

        <div
          class="radio-box"
          *ngFor="let area of pinArea">

          <input
            type="radio"
            [value]="area.Name"
            formControlName="circle">

          <span>{{area.Name}}</span>

        </div>

      </div>



      <div *ngIf="isPinAvailble" class="form-group">

        <label>City</label>

        <input
          class="custom-input"
          type="text"
          readonly
          [(ngModel)]="isCity"
          formControlName="city">

      </div>



      <div *ngIf="isPinAvailble" class="form-group">

        <label>State</label>

        <input
          class="custom-input"
          type="text"
          readonly
          [(ngModel)]="isState"
          formControlName="state">

      </div>



      <div *ngIf="isPinAvailble" class="form-group">

        <label>Business Address</label>

        <textarea
          rows="3"
          class="custom-input"
          formControlName="businessAddress">

        </textarea>

      </div>

 

      <button
        type="submit"
        class="register-btn"
        [disabled]="registerForm.invalid">

        Register

      </button>

   

      <div class="login-link">

        Already have an account?

        <span routerLink="/login">

          Login Now

        </span>

      </div>

    </form>

  </div>

</section> -->




<section class="register-page">

  <img routerLink="/home" style="cursor: pointer;" src="../../assets/images/GoldBharatone 1.png" alt="Gold Bharat"
    class="logo">

  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="new-gold-div">
          <img class="new-gold-img" src="../../assets/images/newlogregimg.png">
        </div>
      </div>
      <div class="col-md-4 new-responsive">
        <div class="register-card">

          <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">

            <h2>Hello! Register to get started</h2>

            <p class="sub-title">Business Information</p>

            <!-- Business Name -->
            <div class="form-group">
              <label>Business Name <span class="required">*</span></label>

              <input type="text" class="custom-input" placeholder="Business Name" formControlName="businessName">

              <small class="validationError"
                *ngIf="registerForm.get('businessName')?.invalid && registerForm.get('businessName')?.touched">

                Business Name is required

              </small>

            </div>

            <!-- Person Name -->

            <div class="form-group">

              <label>Person Full Name <span class="required">*</span></label>

              <input type="text" class="custom-input" placeholder="Person Full Name" formControlName="personName">

              <small class="validationError"
                *ngIf="registerForm.get('personName')?.invalid && registerForm.get('personName')?.touched">

                Person Name is required

              </small>

            </div>

            <!-- Email -->

            <div class="form-group">

              <label>Email <span class="required">*</span></label>

              <input type="email" class="custom-input" placeholder="Email Address" formControlName="email">

              <small class="validationError"
                *ngIf="registerForm.get('email')?.invalid && registerForm.get('email')?.touched">

                Valid Email is required

              </small>

            </div>

            <!-- Phone -->

            <div class="form-group">
              <!-- 
        <label>Phone Number <span class="required">*</span></label>

        <input
          type="text"
          maxlength="10"
          class="custom-input"
          placeholder="Phone Number"
          formControlName="phone">

        <small class="validationError"
          *ngIf="registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched">

          Phone Number is required

        </small> -->
              <label>Phone Number <span class="required">*</span></label>

              <input type="text" maxlength="10" class="custom-input" placeholder="Phone Number" formControlName="phone"
                (input)="onPhoneInput($event)">

              <small class="validationError" *ngIf="registerForm.get('phone')?.hasError('required') &&
         registerForm.get('phone')?.touched">

                Phone Number is required

              </small>

              <small class="validationError" *ngIf="registerForm.get('phone')?.hasError('pattern') &&
         registerForm.get('phone')?.value">

                Please enter a valid 10-digit phone number
                

              </small>

            </div>

            <!-- Establish Date -->

            <div class="form-group">

              <label>Shop Establish Date <span class="required">*</span></label>

              <input type="date" class="custom-input" formControlName="establishedDate">

            </div>

            <!-- Pincode -->

            <div class="form-group">

              <label>Pincode <span class="required">*</span></label>

              <input type="text" maxlength="6" class="custom-input" placeholder="Pincode" formControlName="pincode"
                [(ngModel)]="pin" (input)="getArea()">

            </div>

            <!-- Circle -->

            <div *ngIf="isPinAvailble" class="form-group">

              <label>Circle</label>

              <div class="radio-box" *ngFor="let area of pinArea">

                <input type="radio" [value]="area.Name" formControlName="circle">

                <span>{{area.Name}}</span>

              </div>

            </div>

            <!-- City -->

            <div *ngIf="isPinAvailble" class="form-group">

              <label>City</label>

              <input class="custom-input" type="text" readonly [(ngModel)]="isCity" formControlName="city">

            </div>

            <!-- State -->

            <div *ngIf="isPinAvailble" class="form-group">

              <label>State</label>

              <input class="custom-input" type="text" readonly [(ngModel)]="isState" formControlName="state">

            </div>

            <!-- Address -->

            <div *ngIf="isPinAvailble" class="form-group">

              <label>Business Address</label>

              <textarea rows="3" class="custom-input" formControlName="businessAddress">

        </textarea>

            </div>

            <!-- Button -->

            <button type="submit" class="register-btn" [disabled]="registerForm.invalid">

              Register

            </button>

            <!-- Login -->

            <div class="login-link">

              Already have an account?

              <span routerLink="/login">

                Login Now

              </span>

            </div>

          </form>

        </div>
      </div>
    </div>
  </div>

</section>